import { useTranslation } from 'react-i18next';
import AboutIllustration from '#app/assets/images/about-illustration.svg';
import Illustration from '#app/assets/images/page-illustration.svg';
import Particles from './particles';

export default function HeroAbout() {
	const { t } = useTranslation();

	return (
		<section className="relative">
			{/* Radial gradient */}
			<div
				className="pointer-events-none absolute left-1/2 top-0 -z-10 flex aspect-square w-[800px] -translate-x-1/2 -translate-y-1/2 items-center justify-center"
				aria-hidden="true"
			>
				<div className="translate-z-0 absolute inset-0 rounded-full bg-teal-500 opacity-30 blur-[120px]"></div>
				<div className="translate-z-0 absolute h-64 w-64 rounded-full bg-teal-400 opacity-70 blur-[80px]"></div>
			</div>

			{/* Particles animation */}
			<Particles className="absolute inset-0 -z-10 h-96" quantity={10} />

			{/* Illustration */}
			<div
				className="pointer-events-none absolute left-1/2 -z-10 -mt-16 -translate-x-1/2 opacity-90 blur-2xl md:block"
				aria-hidden="true"
			>
				<img
					src={Illustration}
					className="max-w-none"
					width={1440}
					height={427}
					alt={t('about.pageIllustrationAlt')}
				/>
			</div>

			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				<div className="pb-10 pt-32 md:pt-40">
					{/* Hero content */}
					<div className="text-center">
						<div className="inline-flex bg-gradient-to-r from-teal-500 to-teal-200 bg-clip-text pb-3 font-medium text-transparent">
							{t('about.whoWeAre')}
						</div>
						<h1 className="h1 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-6 text-transparent">
							{t('about.title')}
						</h1>
						<h1 className="h1 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-6 text-transparent">
							{t('about.subtitle')}
						</h1>
						{/* Rings illustration */}
						<div className="relative inline-flex items-center justify-center">
							{/* Particles animation */}
							<div className="absolute inset-0 -z-10" aria-hidden="true">
								<canvas
									data-particle-animation
									data-particle-quantity="10"
								></canvas>
							</div>
							<div className="absolute -top-5 inline-flex h-96 w-96 [mask-image:_radial-gradient(circle_at_bottom,transparent_15%,black_70%)]">
								<img
									src={AboutIllustration}
									width={446}
									height={446}
									alt={t('about.aboutIllustrationAlt')}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
